/**
 * @module types/settings/sortFields
 * @description 排序相关数组字段（X 轴 / 图例）
 */

/** 按指标排序项（chartSorts / customMetricSort / series_sorts） */
export interface IMetricSortValueItem {
  key: string;
  value: 'asc' | 'desc';
  table_code: string;
  /**
   * 字段排序（sortBy=datasetField）时的聚合方式；
   * 指标排序模式下可不传。
   */
  aggregate?: string;
}

/** 图例按指标排序（table_code 必填） */
export interface ISeriesSortValueItem {
  key: string;
  value: 'asc' | 'desc';
  table_code: string;
}

const CHART_SORTS_EMPTY: IMetricSortValueItem[] = Object.freeze(
  [],
) as IMetricSortValueItem[];

const CUSTOM_METRIC_SORT_EMPTY: IMetricSortValueItem[] = Object.freeze(
  [],
) as IMetricSortValueItem[];

const X_AXIS_VALUES_EMPTY: string[] = Object.freeze([]) as string[];

const SERIES_ORDER_EMPTY: string[] = Object.freeze([]) as string[];

const SERIES_SORTS_EMPTY: ISeriesSortValueItem[] = Object.freeze(
  [],
) as ISeriesSortValueItem[];

/** @stable 须与 STRUCTURED_SETTING_DEFAULTS.chartSorts 为同一引用 */
export const CHART_SORTS_DEFAULT: IMetricSortValueItem[] = CHART_SORTS_EMPTY;

/** @stable 须与 STRUCTURED_SETTING_DEFAULTS.customMetricSort 为同一引用 */
export const CUSTOM_METRIC_SORT_DEFAULT: IMetricSortValueItem[] =
  CUSTOM_METRIC_SORT_EMPTY;

/** @stable 须与 STRUCTURED_SETTING_DEFAULTS.xAxisValues 为同一引用 */
export const X_AXIS_VALUES_DEFAULT: string[] = X_AXIS_VALUES_EMPTY;

/** @stable 须与 STRUCTURED_SETTING_DEFAULTS.series_order 为同一引用 */
export const SERIES_ORDER_DEFAULT: string[] = SERIES_ORDER_EMPTY;

/** @stable 须与 STRUCTURED_SETTING_DEFAULTS.series_sorts 为同一引用 */
export const SERIES_SORTS_DEFAULT: ISeriesSortValueItem[] = SERIES_SORTS_EMPTY;
